export default {
  data: function () {
    return {
      positionRef: false
    }
  },
  created: function () {
    this.positionInterval = false
  },
  mounted: function () {
    this.positionInterval = setInterval(() => {
      if (this.$refs.positionRef) {
        clearInterval(this.positionInterval)
        this.positionRef = this.$refs.positionRef
      }
    }, 250)
  },
  beforeDestroy: function () {
    clearInterval(this.positionInterval)
  }
}
